<div class="card">
  <div class="ng-Header col-xs-12">
    <i nz-icon nzType="form" nzTheme="outline"></i> Complete Inspection
  </div>
  <div class="searchboxAerar p-3">
    <form
      nz-form
      [formGroup]="completeInspectForm"
      class="ant-advanced-search-form"
      (ngSubmit)="submitForm()"
    >
      <div class="form-row" style="margin-left: 12px">
        <div class="form-group col-md-3">
          <nz-form-label nzRequired style="margin-left: 15px"
            >Name of STP/SAC</nz-form-label
          >
          <div class="form-group col-md-12">
            <nz-form-item>
              <nz-form-control
                [nzSpan]="null"
                nzHasFeedback
                [nzErrorTip]="stpOrSacNameErrorTpl"
              >
                <input
                  nz-input
                  formControlName="stpOrSacName"
                  placeholder="Name of STP Or SAC"
                  readonly
                />
                <ng-template #stpOrSacNameErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input valid name!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="form-group col-md-3">
          <div class="form-group col-md-12">
            <nz-form-label nzRequired [nzSpan]="null">STP/SAC ID</nz-form-label>
            <nz-form-item>
              <nz-form-control
                [nzSpan]="null"
                nzHasFeedback
                [nzErrorTip]="stpOrSacIdErrorTpl"
              >
                <input
                  nz-input
                  formControlName="stpOrSacId"
                  placeholder="STP or SAC ID"
                  nzAutosize
                  readonly
                />
                <ng-template #stpOrSacIdErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input valid STP Or SAC ID!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="form-group col-md-3">
          <nz-form-label nzRequired style="margin-left: 15px"
            >Application ID</nz-form-label
          >
          <div class="form-group col-md-12">
            <nz-form-item>
              <nz-form-control
                [nzSpan]="null"
                nzHasFeedback
                [nzErrorTip]="applicationIdErrorTpl"
              >
                <input
                  nz-input
                  formControlName="applicationId"
                  placeholder="Application Id"
                  readonly
                />
                <ng-template #applicationIdErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input valid application Id!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="form-group col-md-3">
          <nz-form-label nzRequired style="margin-left: 15px"
            >Date of Application</nz-form-label
          >
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control
                [nzSpan]="null"
                nzHasFeedback
                [nzErrorTip]="dateOfApplicationErrorTpl"
              >
                <nz-date-picker
                  id="DateOfApplication"
                  formControlName="DateOfApplication"
                  placeholder="Date of Application"
                  style="width: 100%"
                  nzDisabled
                >
                </nz-date-picker>
                <ng-template #dateOfApplicationErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input valid Date of Application!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>
      <div class="form-row" style="margin-left: 12px">
        <div class="form-group col-md-3">
          <nz-form-label nzRequired style="margin-left: 15px"
            >Date of inspection conducted</nz-form-label
          >
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control
                [nzSpan]="null"
                nzHasFeedback
                [nzErrorTip]="dateOfApplicationErrorTpl"
              >
                <nz-date-picker
                  id="inspectionConductedDate"
                  formControlName="inspectionConductedDate"
                  placeholder="Date of Application"
                  style="width: 100%"
                  [nzDisabledDate]="disabledDate"
                >
                </nz-date-picker>
                <ng-template #dateOfApplicationErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input valid Date of Application!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="form-group col-md-3">
          <div class="form-group col-md-12">
            <nz-form-label [nzSpan]="null">GPS Location</nz-form-label>
            <nz-form-item>
              <nz-form-control
                [nzSpan]="null"
                nzHasFeedback
                [nzErrorTip]="gpsLocationErrorTpl"
              >
                <input
                  nz-input
                  type="text"
                  formControlName="gpsLocation"
                  placeholder="location"
                  readonly
                />
                <ng-template #gpsLocationErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please select location!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="form-group col-md-3">
          <nz-form-label nzRequired style="margin-left: 15px"
            >Inspection conducted by-1</nz-form-label
          >
          <div class="form-group col-md-12">
            <nz-form-item>
              <nz-form-control
                [nzSpan]="null"
                nzHasFeedback
                [nzErrorTip]="nsdaOfficerIdErrorTpl"
              >
                <nz-select
                  id="nsdaOfficerId"
                  nzShowSearch
                  nzAllowClear
                  formControlName="nsdaOfficerId"
                  nzPlaceHolder="Select Officer"
                >
                  <nz-option
                    *ngFor="let nsdaUser of nsdaUsers"
                    [nzValue]="nsdaUser.id"
                    [nzLabel]="nsdaUser.name"
                  >
                  </nz-option>
                </nz-select>
                <ng-template #nsdaOfficerIdErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please Select!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="form-group col-md-3">
          <nz-form-label style="margin-left: 15px"
            >Inspection conducted by-2</nz-form-label
          >
          <div class="form-group col-md-12">
            <nz-form-item>
              <nz-form-control
                [nzSpan]="null"
                nzHasFeedback
                [nzErrorTip]="inspectionConductedBy1ErrorTpl"
              >
                <nz-select
                  id="nsdaOfficerId"
                  nzShowSearch
                  nzAllowClear
                  formControlName="officer1Id"
                  nzPlaceHolder="Select Officer"
                  (ngModelChange)="onSelectOfficer1($event)"
                >
                  <nz-option
                    *ngFor="let officer of officers1List"
                    [nzValue]="officer.id"
                    [nzLabel]="officer.name"
                  >
                  </nz-option>
                </nz-select>
                <ng-template #inspectionConductedBy1ErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please Select!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>
      <div class="form-row" style="margin-left: 12px">
        <div class="form-group col-md-3">
          <nz-form-label style="margin-left: 15px"
            >Inspection conducted by-3</nz-form-label
          >
          <div class="form-group col-md-12">
            <nz-form-item>
              <nz-form-control
                [nzSpan]="null"
                nzHasFeedback
                [nzErrorTip]="inspectionConductedBy2ErrorTpl"
              >
                <nz-select
                  id="nsdaOfficerId"
                  nzShowSearch
                  nzAllowClear
                  formControlName="officer2Id"
                  nzPlaceHolder="Select Officer"
                  (ngModelChange)="onSelectOfficer2($event)"
                >
                  <nz-option
                    *ngFor="let officer of officers2List"
                    [nzValue]="officer.id"
                    [nzLabel]="officer.name"
                  >
                  </nz-option>
                </nz-select>
                <ng-template #inspectionConductedBy2ErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please Select!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="form-group col-md-3">
          <nz-form-label style="margin-left: 15px"
            >Inspection conducted by-4</nz-form-label
          >
          <div class="form-group col-md-12">
            <nz-form-item>
              <nz-form-control
                [nzSpan]="null"
                nzHasFeedback
                [nzErrorTip]="inspectionConductedBy3ErrorTpl"
              >
                <nz-select
                  id="nsdaOfficerId"
                  nzShowSearch
                  nzAllowClear
                  formControlName="officer3Id"
                  nzPlaceHolder="Select Officer"
                  (ngModelChange)="onSelectOfficer3($event)"
                >
                  <nz-option
                    *ngFor="let officer of officers3List"
                    [nzValue]="officer.id"
                    [nzLabel]="officer.name"
                  >
                  </nz-option>
                </nz-select>
                <ng-template #inspectionConductedBy3ErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please Select!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>
      
      <app-stp-action-history
        *ngIf="stpMainId && applicationId"
        [stpMainId]="stpMainId"
        [applicationId]="applicationId"
      ></app-stp-action-history>
      <hr />
      <div class="row col-md-12" style="margin-left: -6px">
        <div style="margin-top: 5px">
          <b>List of representatives of STP/SAC present during inspection</b>
        </div>
        <div style="margin-left: 10px">
          <button
            type="button"
            class="btn btn-primary"
            (click)="createCustomButtonModal()"
          >
            <i nz-icon nzType="plus" nzTheme="outline"></i>
          </button>
        </div>
      </div>
      <hr />
      <div nz-col [nzSpan]="24" class="mt-3">
        <nz-table
          #listOfRepresentative
          [nzData]="representativeList"
          nzShowSizeChanger
          nzBordered
          nzAlign="middle"
          [nzFrontPagination]="false"
          [nzShowPagination]="false"
          class="css-serial table-striped table"
          [nzScroll]="{ x: '1150px' }"
        >
          <thead>
            <tr>
              <th
                style="text-align: center; width: 8%; vertical-align: middle"
                rowspan="2"
              >
                SI.
              </th>
              <th
                style="text-align: center; width: 25%; vertical-align: middle"
                rowspan="2"
                nzColumnKey=""
              >
                Name
              </th>
              <th
                style="text-align: center; width: 25%; vertical-align: middle"
                rowspan="2"
                nzColumnKey=""
              >
                Designation
              </th>
              <th
                style="text-align: center; width: 25%; vertical-align: middle"
                rowspan="2"
                nzColumnKey=""
              >
                Contact Number
              </th>
              <th
                style="text-align: center; width: 25%; vertical-align: middle"
                rowspan="2"
                nzColumnKey=""
              >
                Email
              </th>
              <th
                style="text-align: center; width: 25%; vertical-align: middle"
                rowspan="2"
                nzColumnKey=""
              >
                Action
              </th>
              <th style="text-align: center; width: 25%; vertical-align: middle; display: none;" rowspan="2" nzColumnKey=""> Id</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of listOfRepresentative.data; let i = index">
              <td style="text-align: center">{{ 1 + i }}</td>
              <td>{{ data.name }}</td>
              <td>{{ data.designation }}</td>
              <td>{{ data.phone }}</td>
              <td>{{ data.email }}</td>
              <td style="display: none">{{ data.id }}</td>
              <td>
                <i
                  style="margin-left: 10px; color: red"
                  title="Delete"
                  nz-icon
                  nzType="minus-circle-o"
                  class="dynamic-delete-button"
                  *ngIf="data.name != ''"
                  (click)="removeField(i)"
                ></i>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </div>
      <div class="row justify-content-center media-button pt-3">
        <div class="col-sm-5 col-md-2 col-xs-2">
          <button
            [disabled]="saveButtonDisabled || isCompleteInspectionSubmitted"
            type="submit"
            class="btn btn-success active btn-lg btn-block cari border-redius"
            [title]="
              isCompleteInspectionSubmitted
                ? 'Already submitted by the NSDA officer; the inspection details are locked'
                : 'Save the inspection date, attendance and representatives without submitting'
            "
          >
            <i nz-icon nzType="save" nzTheme="fill"></i> Save Draft
          </button>
        </div>
      </div>

      <br />
      <nz-card *ngIf="correctionRemarks">
        <div class="ng-Header col-xs-12">
          <i nz-icon nzType="form" nzTheme="outline"></i> Required Corrections
          Info
        </div>
        <div class="searchboxAerarWithoutShadow">
          <nz-table
            #otherRequirementTable
            [nzData]="['']"
            nzTableLayout="fixed"
            nzShowSizeChanger
            nzBordered
            nzSize="middle"
            nzAlign="middle"
            [nzFrontPagination]="false"
            [nzScroll]="{ x: '1150px' }"
          >
            <thead>
              <tr>
                <th>Correction Remarks</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td [innerText]="correctionRemarks"></td>
              </tr>
            </tbody>
          </nz-table>
        </div>
      </nz-card>

      <hr />
      <b style="margin-left: 10px">Detailed Inspection Reports</b>
      <hr />
      <div nz-col [nzSpan]="24">
        <nz-table
          *ngIf="this.listTamOccupation.length > 0"
          #detailedInspectionReport
          [nzData]="listTamOccupation"
          nzTableLayout="fixed"
          nzBordered
          [nzFrontPagination]="false"
          [nzShowPagination]="false"
          nzSize="middle"
          nzAlign="middle"
          [nzScroll]="{ x: '1150px' }"
        >
          <thead>
            <tr>
              <th
                style="text-align: center; vertical-align: middle"
                rowspan="2"
              >
                SI.
              </th>
              <th
                style="text-align: center; width: 25%; vertical-align: middle"
                rowspan="2"
                nzColumnKey=""
              >
                Application for
              </th>
              <th
                style="text-align: center; width: 25%; vertical-align: middle"
                rowspan="2"
                nzColumnKey=""
              >
                Application Type
              </th>
              <th
                style="text-align: center; width: 15%; vertical-align: middle"
                rowspan="2"
              >
                Action
              </th>
              <th colspan="4">Report Submitted by</th>
            </tr>
            <tr>
              <th
                style="text-align: center; vertical-align: middle"
                rowspan="2"
              >
                Assigned officer-1?
              </th>
              <th
                style="text-align: center; vertical-align: middle"
                rowspan="2"
              >
                Assigned officer-2?
              </th>
              <th
                style="text-align: center; vertical-align: middle"
                rowspan="2"
              >
                Assigned officer-3?
              </th>
              <th
                style="text-align: center; vertical-align: middle"
                rowspan="2"
              >
                Assigned officer-4?
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let data of detailedInspectionReport.data;
                let i = index;
                let f = first
              "
            >
              <td style="text-align: center">{{ 1 + i }}</td>
              <td>
                {{ data.occupationName }}
                {{
                  data.type == "Occupation"
                    ? ", Level-" + data.occupationLevel
                    : ""
                }}
              </td>
              <td>{{ data.applicationType }}</td>
              <td style="text-align: center; vertical-align: middle">

                <div *ngIf="data.type == 'STP'">
                  <button
                    type="button"
                    (click)="
                      onEditStpSac(
                        inspectionId,
                        data.inspectionRegistrationReportId
                      )
                    "
                    nz-button
                    nzType="default"
                    [nzSize]="'small'"
                  >
                    <i nz-icon nzType="edit" nzTheme="fill"></i>
                  </button>
                  |
                  <button
                    type="button"
                    (click)="onViewStpSac(inspectionId)"
                    nz-button
                    nzType="default"
                    [nzSize]="'small'"
                  >
                    <i nz-icon nzType="eye" nzTheme="fill"></i>
                  </button>
                </div>
              </td>
              <td style="text-align: center; vertical-align: middle">
                {{ completeInspectionList.isNsdaApproved ? "Yes" : "No" }}
              </td>
              <!-- Each column uses its own officer's flags: Yes = approved, Pending = present but not approved, NA = not present -->
              <td style="text-align: center; vertical-align: middle">
                {{ officerApprovalLabel(1) }}
              </td>
              <td style="text-align: center; vertical-align: middle">
                {{ officerApprovalLabel(2) }}
              </td>
              <td style="text-align: center; vertical-align: middle">
                {{ officerApprovalLabel(3) }}
              </td>
            </tr>
          </tbody>
        </nz-table>
      </div>
      <!-- After the NSDA officer submits, the status stays "Inspection Scheduled" until every present inspector approves -->
      <div class="mt-3" *ngIf="isCompleteInspectionSubmitted">
        <nz-alert
          *ngIf="pendingInspectorNames.length; else allInspectorsApprovedTpl"
          nzType="warning"
          nzShowIcon
          nzMessage="Submitted by NSDA officer - waiting for inspector approval"
          [nzDescription]="pendingInspectorsTpl"
        ></nz-alert>
        <ng-template #pendingInspectorsTpl>
          Waiting for approval from:
          <strong>{{ pendingInspectorNames.join(', ') }}</strong>.
          Each of them received a review link by email. The application status
          changes to <strong>Inspection Completed</strong>, and scrutiny can start, only
          after all of them approve from that link.
          <div class="mt-2">
            If someone did not get the email, send the same link again:
            <span *ngFor="let officer of pendingInspectors; trackBy: trackByOfficerId" class="mr-2">
              <button
                nz-button
                nzSize="small"
                [nzLoading]="resendingOfficerId === officer.id"
                [disabled]="resendingOfficerId !== null"
                [appRequiredPermission]="
                  applicationPermissions.stpRegistration.stpRenewReapplyApplication
                    .submitRenewReapplyInspectionCompletionReport
                "
                (click)="resendApprovalLink(officer.id)"
              >
                <i nz-icon nzType="mail"></i> Resend to {{ officer.name }}
              </button>
            </span>
          </div>
        </ng-template>
        <ng-template #allInspectorsApprovedTpl>
          <nz-alert
            nzType="success"
            nzShowIcon
            nzMessage="Submitted by NSDA officer"
            nzDescription="All inspectors present during the inspection have approved. The inspection is complete and can move to scrutiny."
          ></nz-alert>
        </ng-template>
      </div>
      <div class="row justify-content-center media-button pt-3">
        <div class="col-sm-5 col-md-2 col-xs-2 mt-2">
          <button
            [disabled]="submitButtonDisabled || isCompleteInspectionSubmitted"
            [title]="isCompleteInspectionSubmitted ? 'Already submitted by the NSDA officer' : ''"
            type="button"
            class="btn btn-success active btn-lg btn-block cari border-redius"
            [appRequiredPermission]="
              applicationPermissions.stpRegistration.stpRenewReapplyApplication
                .submitRenewReapplyInspectionCompletionReport
            "
            nz-popconfirm
            nzPopconfirmTitle="Submitting will save the inspection details, lock this inspection and notify the assigned inspectors. Continue?"
            nzPopconfirmPlacement="top"
            (nzOnConfirm)="onSubmitCompleteInspection()"
          >
            <i nz-icon nzType="send" nzTheme="outline"></i> Submit
          </button>
        </div>
        <div *ngIf="this.inspectionRegistrationReportId" class="col-sm-5 col-md-2 col-xs-2 mt-2">
          <button
            type="button"
            class="btn btn-success active btn-lg btn-block cari border-redius"
            [appRequiredPermission]="
              applicationPermissions.courseAccreditation.completeInspection
                .genericPermission
            "
            (click)="downloadSummaryPdf()"
          >
            <span nz-icon nzType="download" nzTheme="outline"></span> Download
            Summary
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
